import React from 'react';
import AutoCompleteFilter from 'components/list/Filters/types/AutoCompleteFilter';

const ProductIdFilter = <AutoCompleteFilter
    label='filters.components.productId.label'
    options={ {
        fullWidth: true,
    } }
    searchParams={ {
        size: '12',
        sort_by: 'title',
        sort_direction: 'asc',
    } }
    reference='products'
    optionValue='id'
    searchBy='title'
    source='product_id'
/>;

export default ProductIdFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/ProductIdFilter.js